@file:Suppress("ALL")

package com.klantenstop.web.bindings

// More information can be found at https://leafletjs.com/reference.html
// Build upon the 1.9.4 version of Leaflet.js and Leaflet.markercluster 1.5.3
// Can be updated in the `build.gradle.kts` file of the `core` module

external object L {
    fun latLngBounds(points: Array<Array<Double>>): LatLngBounds
    fun map(id: String, options: dynamic = definedExternally): LeafletMap
    fun tileLayer(url: String, options: dynamic = definedExternally): TileLayer
    fun marker(latLng: Array<Double>, options: dynamic = definedExternally): Marker
    fun markerClusterGroup(options: dynamic = definedExternally): MarkerClusterGroup

    fun circle(latLng: Array<Double>, options: dynamic = definedExternally): Circle

    fun icon(options: dynamic = definedExternally): Icon
}

external interface LeafletMap {
    val scrollWheelZoom: ScrollZoom

    fun setView(latLng: Array<Double>, zoom: Int, options: dynamic = definedExternally): LeafletMap
    fun addLayer(layer: dynamic)
    fun removeLayer(layer: dynamic)

    fun fitBounds(bounds: LatLngBounds, options: dynamic = definedExternally)
}

external interface TileLayer {
    fun addTo(map: LeafletMap)
}

external interface Marker {
    fun bindPopup(text: String): Marker
    fun bindPopup(element: org.w3c.dom.HTMLElement): Marker
}

external interface MarkerClusterGroup {
    fun clearLayers()
    fun addLayer(marker: Marker)
    fun addTo(map: LeafletMap)
}

external interface ScrollZoom {
    fun enable()
    fun disable()
}

/**
 * Sealed interface for map marker popup content.
 * Provides compile-time type safety for popup content types.
 */
sealed interface PopupContent {
    /**
     * Popup content as a DOM element (e.g., for interactive content with event handlers).
     */
    data class Element(val element: org.w3c.dom.HTMLElement) : PopupContent

    /**
     * Popup content as plain HTML string.
     */
    data class Html(val html: String) : PopupContent
}

data class MapPin(
    val lat: Double,
    val lng: Double,
    val label: String,
    val iconUrl: String?,
    val popUpContent: PopupContent? = null
)

external interface LatLngBounds

external interface Circle {
    fun addTo(map: LeafletMap): Circle
    fun setRadius(radius: Int)
    fun getBounds(): LatLngBounds
    fun setLatLng(latLng: Array<Double>)
}

external interface Icon

data class LeafletState(
    val map: LeafletMap,
    val clusters: MarkerClusterGroup,
    var radiusCircle: Circle? = null
)

fun createLeafletMap(
    mapId: String
): LeafletState {
    val map = L.map(
        id = mapId,
        options = js(
            """
            {
              center: [50.8467, 4.3525],
              zoom: 9,
              gestureHandling: true
            }
        """
        )
    )

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png")
        .addTo(map)

    val clusters = L.markerClusterGroup(
        js(
            """
        {
          showCoverageOnHover: true,
          polygonOptions: {
            color: "#364D2E",
            weight: 2,
            opacity: 0.8,
            fillColor: "#364D2E",
            fillOpacity: 0.2
          }
        }
    """
        )

    )
    clusters.addTo(map)

    return LeafletState(map, clusters)
}
